import React from 'react'

import styled from '@emotion/styled'
import {
  Box,
  Display,
  FlexDirection,
  JustifyContent,
  AlignItems,
  Icon,
  IconVariant,
  BorderStyle,
  Color,
  colors,
  DisplayPosition,
  ZIndex,
} from '@gousto-internal/citrus-react'

export enum TooltipVariant {
  LIGHT,
  DARK,
}
export enum TooltipArrowType {
  NONE,
  RIGHT,
  LEFT,
  TOP_RIGHT,
}

const TooltipText = styled.span<{ textColor: string }>(({ textColor }) => ({
  fontWeight: 600,
  fontSize: '11px',
  lineHeight: '16px',
  color: textColor,
  fontFamily: 'AxiformaSemiBold',
}))
const TooltipArrow = styled.div<{ color: string; arrow?: TooltipArrowType }>(
  ({ color, arrow }) => ({
    width: 0,
    height: 0,
    borderLeft: '4px solid transparent',
    borderRight: '4px solid transparent',
    zIndex: 0,

    position: 'absolute',

    ...(arrow === TooltipArrowType.TOP_RIGHT
      ? {
          borderBottom: `7px solid ${color}`,
          top: '-6px',
          right: '5px',
        }
      : {}),

    ...(arrow === TooltipArrowType.LEFT
      ? {
          left: '5px',
          borderTop: `7px solid ${color}`,
          bottom: '-6px',
        }
      : {}),
    ...(arrow === TooltipArrowType.RIGHT
      ? {
          right: '5px',
          borderTop: `7px solid ${color}`,
          bottom: '-6px',
        }
      : {}),
  }),
)

type TooltipProps = {
  variant: TooltipVariant
  text: string
  arrow?: TooltipArrowType
}

export const Tooltip = ({ variant, text, arrow = TooltipArrowType.NONE }: TooltipProps) => (
  <Box position={DisplayPosition.Relative}>
    <Box
      data-testid={
        variant === TooltipVariant.LIGHT
          ? 'HowGoustoWorksTooltipLight'
          : 'HowGoustoWorksTooltipDark'
      }
      boxShadow="0px 2px 4px rgba(101, 102, 103, 0.2)"
      bg={variant === TooltipVariant.LIGHT ? Color.White : Color.ColdGrey_900}
      paddingH={1}
      paddingV={1}
      borderWidth={variant === TooltipVariant.LIGHT ? 0.5 : 0}
      borderStyle={BorderStyle.Solid}
      borderColor={Color.ColdGrey_100}
      gap={1}
      display={Display.Flex}
      flexDirection={FlexDirection.Row}
      justifyContent={JustifyContent.Center}
      alignItems={AlignItems.Center}
      borderRadius={1.5}
      zIndex={ZIndex.Top}
    >
      <Box
        display={Display.Flex}
        flexDirection={FlexDirection.Row}
        alignItems={AlignItems.Center}
        justifyContent={JustifyContent.Center}
        gap={1}
      >
        <Icon name="tick" variant={IconVariant.Confirmation} size={4} />
        <TooltipText
          textColor={
            variant === TooltipVariant.LIGHT ? colors[Color.ColdGrey_900] : colors[Color.White]
          }
        >
          {text}
        </TooltipText>
      </Box>
    </Box>

    {arrow !== TooltipArrowType.NONE && (
      <TooltipArrow
        color={variant === TooltipVariant.LIGHT ? colors[Color.White] : colors[Color.ColdGrey_900]}
        arrow={arrow}
      />
    )}
  </Box>
)
